import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from '@agilemd/ui-icon';
import { getGlobalParam } from '@agilemd/ui-utils';

import * as agilemd from '../../services/api.js';
import { ICONS } from '../../utils/fontawesome.js';

const VERSION = getGlobalParam('version');

class Feedback extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this.onChangeCategory = this.onChangeCategory.bind(this);
    this.onChangeComments = this.onChangeComments.bind(this);
    this.onChangeIsAnonymous = this.onChangeIsAnonymous.bind(this);
    this.onClickBanner = this.onClickBanner.bind(this);
    this.onClickIcon = this.onClickIcon.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
    this.renderCategories = this.renderCategories.bind(this);
    this.renderCategory = this.renderCategory.bind(this);
    this.renderInput = this.renderInput.bind(this);
  }

  getInitialState() {
    return {
      isActive: false,
      isAnonymous: null,
      category: null,
      comments: null
    };
  }

  onChangeIsAnonymous(e) {
    const isChecked = e.target.checked;

    this.setState({
      isAnonymous: isChecked
    });
  }

  onChangeCategory(e) {
    const category = e.target.value;

    this.setState({
      category
    });
  }

  onChangeComments(e) {
    const comments = e.target.value;

    this.setState({
      comments
    });
  }

  onClickBanner() {
    this.setState(this.getInitialState());
  }

  onClickIcon() {
    const { isActive } = this.state;

    const state = this.getInitialState();

    state.isActive = !isActive;

    this.setState(state);
  }

  onClickSubmit() {
    const { isAnonymous } = this.state;
    const { category } = this.state;
    const { comments } = this.state;

    agilemd.postFeedback(isAnonymous, category, comments);

    this.setState(this.getInitialState());
  }

  renderCategories() {
    const { categories } = this.props;

    if (categories.length === 0) {
      return null;
    }

    return (
      <div className="feedback__form__category-list">
        <ul>{categories.map(this.renderCategory)}</ul>
      </div>
    );
  }

  renderCategory(category, i) {
    const { category: currentCategory } = this.state;
    const isChecked = currentCategory === category;

    return (
      <li className="feedback__form__category-list__item" key={i}>
        <label>
          <input
            checked={isChecked}
            name="category"
            type="radio"
            value={category}
            onChange={this.onChangeCategory}
          />
          <span className="feedback__form__category-list__item__text">{category}</span>
        </label>
      </li>
    );
  }

  renderInput() {
    const { comments } = this.state;
    const { prompt } = this.props;

    return (
      <div className="feedback__form">
        <span className="arrow arrow__up-border" />
        <span className="arrow arrow__up" />
        <div
          className="feedback__form__banner"
          onClick={this.onClickBanner}
          tabIndex={-1}
          role="button"
        >
          <span className="feedback__form__banner__prompt">{prompt}</span>
          <Icon icon={ICONS.CLOSE} />
        </div>
        {this.renderCategories()}
        <div className="feedback__form__comments">
          <textarea placeholder="Your comments..." onChange={this.onChangeComments}>
            {comments}
          </textarea>
        </div>
        <div className="feedback__form__submit">
          <div className="feedback__form__submit__anonymous">
            <label className="feedback__form__submit__anonymous__label">
              <input
                name="isAnonymous"
                type="checkbox"
                value="true"
                onClick={this.onChangeIsAnonymous}
              />
              <span className="feedback__form__submit__anonymous__label__text">
                Submit anonymously
              </span>
            </label>
          </div>
          <div className="feedback__form__submit__button">
            <button className="button button--primary" onClick={this.onClickSubmit} type="button">
              Send feedback
            </button>
          </div>
        </div>
        <div className="feedback__form__about">
          <div>{`AgileMD ${String.fromCharCode(183)} SURPAS`}</div>
          <div className="feedback__form__about__version">
            Version
            {VERSION}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { isActive } = this.state;

    const feedbackIcon = ICONS.FEEDBACK;
    const feedbackInputEl = isActive ? this.renderInput() : null;

    const feedbackIconClassNames = ['feedback__icon'];

    if (isActive) {
      feedbackIconClassNames.push('feedback__icon--active');
    }

    return (
      <div className="feedback">
        <div
          className={feedbackIconClassNames.join(' ')}
          onClick={this.onClickIcon}
          tabIndex={-1}
          role="button"
        >
          <Icon icon={feedbackIcon} />
        </div>
        {feedbackInputEl}
      </div>
    );
  }
}
Feedback.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  prompt: PropTypes.string.isRequired
};

export default Feedback;
